export const ROLE_USER = {
  teacher: "teacher",
  student: "student",
  admin: "admin",
};
